import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const PARTNERS_API = "https://fetc.in/api/v1/partners";

export const partnersApi = createApi({
  reducerPath: "partnersApi",
  tagTypes: ["Partners"],
  baseQuery: fetchBaseQuery({
    baseUrl: PARTNERS_API,
    credentials: "include",
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    createPartner: builder.mutation({
      query: (formData) => ({
        url: "/create",
        method: "POST",
        body: formData, // assuming formData is already JSON or FormData
      }),
      invalidatesTags: ["Partners"],
    }),

    getPartners: builder.query({
      query: () => "/list",
      providesTags: ["Partners"],
    }),

    getPartnerById: builder.query({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: "Partners", id }],
    }),

    updatePartner: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/${id}`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Partners", id },
        "Partners",
      ],
    }),

   deletePartner: builder.mutation({
  query: (id) => ({
    url: `/${id}`,
    method: "DELETE",
  }),
 invalidatesTags: ["Partners"], 
    }),
  }),
});

export const {
  useCreatePartnerMutation,
  useGetPartnersQuery,
  useGetPartnerByIdQuery,
  useUpdatePartnerMutation,
  useDeletePartnerMutation,
} = partnersApi;
